import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { OperationResultEntity } from "../../../Data/MedicinalProductData/OperationResultEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { DateUtil } from "../../../DateUtil";
import { TreeNodeMedicinalProductsXevprmMessage } from "../ListEntity/TreeNodeMedicinalProductsXevprmMessage";
import { SimpleSearchListNode } from "../../SimpleSearchListNode";
import { DummyNode } from "../../DummyNode";

export class TreeNodeMessageResultEntity extends BaseNode {
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any) {
        super(injector, new OperationResultEntity(injector,model), labelTemplate);
        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
        const simpleSearchXevprmMessageNode = new TreeNodeMedicinalProductsXevprmMessage(injector, [], false);
        if (model.messages && model.messages != null && model.messages.length > 0) {
          simpleSearchXevprmMessageNode.loadEntityNode(model.messages, true); // fix recursivity from treenode design for UI
          simpleSearchXevprmMessageNode.labelTemplate = `XEVPRM Message (${model.messages.length})`;  
          simpleSearchXevprmMessageNode.refreshLabel();
          this.children?.push(simpleSearchXevprmMessageNode);
        } else {
          this.children?.push(new DummyNode('XEVPRM Message (-)'));
        }

    }

    public getListItem(): any[] {
        return [this.data.model.entity,this.data.model.localnumber,this.data.model.ev_Code,this.ioc?.get(LookupGetService).retrieveValueFromCache('operationtypeoperationresult',this.data.model.operationtype),this.ioc?.get(LookupGetService).retrieveValueFromCache('operationresult',this.data.model.operationresult),DateUtil.getDateTimeFormat(this.data.model.operationdate),this.data.model.message];
    }

    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: TreeNodeMessageResultEntity = new TreeNodeMessageResultEntity(
        this.ioc!,
        this.labelTemplate,
        newParent,
        this.data.model
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      return clonedNode;
    }

}